import { render, staticRenderFns } from "./personal-info-setting.vue?vue&type=template&id=6ffb76c6&scoped=true&"
import script from "./personal-info-setting.vue?vue&type=script&lang=js&"
export * from "./personal-info-setting.vue?vue&type=script&lang=js&"
import style0 from "./personal-info-setting.vue?vue&type=style&index=0&id=6ffb76c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb76c6",
  null
  
)

export default component.exports